import { render, staticRenderFns } from "./TenantsViewer.vue?vue&type=template&id=6028429f&scoped=true&"
import script from "./TenantsViewer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TenantsViewer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TenantsViewer.vue?vue&type=style&index=0&id=6028429f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028429f",
  null
  
)

export default component.exports